import React from "react";
import { withRouteData, NavLink } from "react-static";
import Moment from "react-moment";
import Markdown from "react-markdown";
import { Head } from "react-static";
import PostStyle from "../styles/post.style";
import BlogStyle from "../styles/blog.style";
import { LazyImage } from 'react-lazy-images'
import { truncate } from "../helpers/utils";
import right_arrow from "../assets/right-arrow.svg";

const Post = ({ post, similar }) => {

  return (
    <PostStyle>
      <Head>
        <title>Investiv Group | Blog - {post.data.title}</title>
      </Head>

      <div className="xs-12 content">

        <div className="xs-12 header">

        <NavLink id="b2b" to = "/our-work">Back To Blog</NavLink>

          <img className="image" src={post.data.thumbnail} alt="" />

          <div className="in-header-content">
            <h3> {post.data.title} </h3>
            <p>{post.data.imageCaption || post.data.excerpt}</p>
            <span><Moment format="MMMM Do, YYYY">{post.data.date}</Moment></span>
          </div>

        </div>

        <div className="xs-12 md-10 md-off-1 lifted">

          <div className="xs-12 t-c">
            <p style={{ margin: 0, padding: 0, fontSize: "14px"}}>{post.data.imageCaption}</p>
          </div>
          <div className="xs-12 ">
            <h3 id="post-title">{post.data.title}</h3>
            <Moment format="MMMM Do, YYYY">{post.data.date}</Moment>
            <Markdown source={post.content} escapeHtml={false} />
          </div>

          <BlogStyle className="xs-12 top">
            <div className="xs-12">
              <h3 className="t-c black">Articles similaires</h3>
            </div>

            <section className="xs-12" id="blog">
              <div className="xs-12">
                {similar.map(post => (
                  <div className="xs-12 sm-4 post-card" key={post.data.slug}>
                    <div className="xs-12 sm-11 inner">

                      <LazyImage
                      placeholder={({ imageProps, ref }) => (
                        <div className="imgPlaceholder" ref={ref} />)}
                      actual={({ imageProps }) => (<img {...imageProps} />)}
                      src={post.data.thumbnail} className="image" />

                      <div className="inner-inner">
                        <h3>{post.data.title}</h3>
                        <p>{truncate(post.content)}</p>

                        <NavLink to={`/our-work/post/${post.data.slug}`}>
                          Lire la suite
                          <img src={right_arrow} className="arrow" />
                        </NavLink>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </BlogStyle>
        </div>
      </div>
    </PostStyle>
  );
}

let PostPage = withRouteData(Post);
export default PostPage;



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Post.js